<template>
  <img src="/psppm-logo.png" alt="logo" class="w-auto h-8 inline align-text-bottom"/>
</template>
